(() => {
  document.addEventListener('DOMContentLoaded', () => {
    if (!document.querySelector('.burger-menu')) {
      return
    }

    document.querySelector('.burger-menu').addEventListener('click', (e) => {
      document.querySelector('.burger-menu').classList.toggle('collapsed')
      document.querySelector('.ce_header_mobile').classList.toggle('ce_header_mobile_open')
    })
  })
}) ()